/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable, ApplicationRef } from '@angular/core';
import { IceNavService } from '../../../src/components/ice-nav/ice-nav.service';
import { BaseAppService } from '../baseapp.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { LoginService } from '../../login/login.service';

declare var require: any;
let fullpatientport: boolean = true;
let currentEnv: any = require("../../../../../env.json").currentEnv;
let envs: any = require("../../../../../env.json").environments;
if (envs != null) {
  fullpatientport = envs[currentEnv].fullpatientport;
}

@Injectable()
export class PatientAppService extends BaseAppService {

  constructor(navSvc: IceNavService, domainSvc: DomainService, loginSvc: LoginService, app: ApplicationRef) {
    super(navSvc, domainSvc, loginSvc, app);
  }

  public defaultMenus() {
    super.defaultMenus();
    let navSvc: IceNavService = super.getNavService();
    let ptact: string = this.getCurrentPatient();
    let currAct: string = this.getCurrentAccount();
    if (this.getMainAppChildMode() == false) {
      if (ptact != null && ptact.length > 0 && currAct != null && currAct.length > 0 && currAct != ptact)
        navSvc.insertSideRoute(null, "dashboard", null, "dashboard", "Home", "fas fa-home", 0, "PHR");
      else
        navSvc.insertSideRoute(null, "dashboard", null, "dashboard", "Home", "fas fa-home", 0);
    } else {
      navSvc.showTopMenuParent(navSvc.topMenuMessagesParentElementID, false);
      navSvc.showTopMenuParent(navSvc.topMenuLogoutParentElementID, false);
    }

    if (this.getCurrentAccountType() == IceTypes.ACCOUNT_TYPE.actPatient)
      navSvc.insertSideRoute(null, "patientdashboard", null, "patientdashboard", "Dashboard", "fas fa-tachometer-alt", 0);

    navSvc.insertSideRoute(null, "phrcontact", null, "patientportal/contact", "Contact Information", "fas fa-address-card", 0);
    navSvc.insertSideRoute(null, "phrproviders", null, "patientportal/careteam", "Care Team", "fas fa-user-md", 0);
    navSvc.insertSideRoute(null, "phrappointments", null, "patientportal/appointments", "Appointments", "fas fa-calendar-check", 0);

    if (fullpatientport) {
      navSvc.insertSideRoute(null, "phrmedications", null, "patientportal/medications", "List of Medications", "fas fa-address-card", 0);
      navSvc.insertSideRoute(null, "phrproblems", null, "patientportal/problems", "List of Problems", "fas fa-diagnoses", 0);
      navSvc.insertSideRoute(null, "phrallergies", null, "patientportal/allergies", "Allergies", "fas fa-leaf", 0);
      // Not supported in this release
      // navSvc.insertSideRoute(null, "phrclinalsummaries", null, "patientportal/clinalsummaries", "Clinical Summaries", "fas fa-stethoscope", 0);
      navSvc.insertSideRoute(null, "phrorders", null, "patientportal/orders", "Orders", "fas fa-medkit", 0);
      navSvc.insertSideRoute(null, "phrdocuments", null, "patientportal/documents", "Documents", "fas fa-file-alt", 0);
    }

    navSvc.insertSideRoute(null, "phrsettings", null, "patientportal/settings", "Settings", "fas fa-cog", 0);
  }
}
